var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCassiopeiaBadgeTwitter = function SvgCassiopeiaBadgeTwitter(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.795,
    height: 50,
    fill: "none",
    viewBox: "0 0 38.795 50",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.349,
    cy: 6.185,
    rx: 27.424,
    ry: 27.734,
    style: {
      fill: "#fff",
      fillOpacity: 0.233099,
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 1.10173,
      strokeOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M19.29 5.578 14.651 8.29l-5.29.107-2.428 4.409-4.41 2.578.029 5.373L0 25.39l2.604 4.304.027 5.11 4.668 2.66 2.738 4.53 5.031-.102 4.438 2.529 4.637-2.711 5.293-.107 2.427-4.409 4.41-2.578-.029-5.375 2.55-4.633-2.6-4.304-.03-5.11-4.668-2.66-2.738-4.53-5.031.102z",
    style: {
      fill: "#1da1f2",
      fillOpacity: 1,
      stroke: "#0f72af",
      strokeWidth: 1,
      strokeDashoffset: 1.10173,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m21.27 23.46 7.33-8.521h-1.736l-6.365 7.398-5.083-7.398H9.553l7.687 11.187-7.687 8.935h1.737l6.72-7.813 5.37 7.813h5.862L21.27 23.46zm-2.378 2.765-.78-1.114-6.196-8.865h2.668l5 7.154.78 1.114 6.5 9.299h-2.668l-5.304-7.588z",
    style: {
      fill: "#dfdfdf",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.29 0-4.638 2.71-5.29.108-2.428 4.409-4.41 2.578.029 5.373L0 19.813l2.604 4.304.027 5.11 4.668 2.66 2.738 4.529 5.031-.102 4.438 2.53 4.637-2.711 5.293-.108 2.427-4.408 4.41-2.578-.029-5.375 2.55-4.633-2.6-4.304-.03-5.11-4.668-2.66-2.738-4.53-5.031.102z",
    mask: "url(#a)",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1,
      strokeDashoffset: 1.10173
    },
    transform: "translate(0 5.578)"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCassiopeiaBadgeTwitter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cassiopeia-badge-twitter.35edca0d795bbd9559420f37e3033c6e.svg";